export default "__VITE_ASSET__CjUDKxdo__"